import React from "react";
import App from "../Layouts/AppLayout";
import { Section, Button } from "../Components";
import { Header } from "../Components/PageSections";
import Contact from "../Components/PageSections/Contact";

export default function AboutUs() {

  const values = [
    { color: '#0D9554', text: 'Trust' },
    { color: '#ED6B6B', text: 'Security' },
    { color: '#FFFFFF', text: 'Transparency' },
    { color: '#FDAE09', text: 'Speed' },
  ]

  const journey = [
    { year: '2020', text: 'POD launched in USA August 1st 2020' },
    { year: '2022', text: 'We also gained our first 1000 sellers' },
    { year: '2023', text: 'We launched another branch in Nigeria in may' },
    { year: '2024', text: 'We expanded to more states in both Nigeria and USA' },
  ]

  return (
    <App hasHeader={false}>
      <div className="tw-bg-primary">
        <Header dark={true} />

        <Section className="md:max-w-70 tw-text-white tw-space-y-6">
          <div>
            <h1 className="tw-text-white">Our Mission</h1>
            <p className="tw-px-4 tw-py-2 md:tw-py-4 tw-rounded-md" style={{
              borderLeft: '3px solid blue'
            }}>To provide secure, transparent, and reliable escrow solutions for e-commerce transactions, ensuring trust and peace of mind for buyers and sellers worldwide. One country at a time.</p>
          </div>

          <div>
            <h1 className="tw-text-white">Our Vision</h1>
            <p className="tw-px-4 tw-py-2 md:tw-py-4 tw-rounded-md" style={{
              borderLeft: '3px solid blue'
            }}>We aspire to become the leading global platform for secure online transactions, fostering a safer and more trustworthy digital marketplace for all.</p>
          </div>

          <div>
            <p className="h3 tw-text-white">Our core values</p>
            <div className="tw-flex tw-flex-wrap tw-gap-4 md:tw-gap-8">
              {values.map((value, index) => (
                <div key={index} className="tw-flex tw-items-center tw-gap-2">
                  <div className="tw-w-2 tw-h-2 tw-rounded-full" style={{
                    backgroundColor: value.color
                  }}></div>
                  <p className="tw-text-white">{value.text}</p>
                </div>
              ))}
            </div>
          </div>
        </Section>
      </div>

      <Section>
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 md:tw-gap-4">
          <div>
            <p>Our Journey: From Idea to Impact</p>
            <h2>Our Journey</h2>
          </div>

          <p className="md:tw-col-span-2">Founded in 2020, we started with a simple goal: to create a secure platform for online transactions that people could trust. Since then, we've grown into a trusted partner for thousands of customers, providing escrow services for e-commerce, real estate, and more. Our commitment to security, transparency, and customer satisfaction has been the foundation of our success.</p>
        </div>

        <div className="tw-flex tw-gap-4 md:tw-gap-8 tw-flex-col md:tw-flex-row tw-justify-between tw-mt-4 md:tw-mt-6">
          {journey.map((_, i) => (
            <div className="tw-text-center">
              <p style={{ color: '#6D60F6' }}>{_.year}</p>
              <p>{_.text}</p>
            </div>
          ))}
        </div>
      </Section>

      <div className="tw-bg-primary">
        <Section className="tw-flex md:tw-items-center tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-24">
          <div className="tw-flex-1">
            <p className="tw-text-white">We would love to have you onboard.</p>
            <h3 className="tw-text-white">Join our team. Let's make magic happen in the world of E-commerce</h3>
          </div>
          <Button title={'See openings'} illustrated />
        </Section>
      </div>

      <Section className="tw-flex tw-items-center tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-24">
        <div>
          <p className="tw-font-extrabold" style={{
            fontWeight: 800
          }}>We Have You At Heart</p>
          <p>We are committed to delivering excellence. We care about your feelings and we love to get the feedback of each and every one of our user — big or small, individual or company.</p>
          <h4>We're Passionate About Our Users.</h4>
        </div>

        <div>
          <img
            src="/assets/images/pod-users.png"
            alt="Safe Transactions"
            width={499}
            className="tw-h-auto tw-max-w-full"
            style={{width: '499px'}}
          />
        </div>
      </Section>

      <Contact />
    </App>
  );
}
